import { useEffect, useState } from 'react';
import { Case } from '../../../data/types';
import { useCaseService } from '../../../data/services';
import { CaseControl } from '../CaseControl';
import { DropdownMenu } from '../Menus/DropdownMenu';

export type CaseDropdownProps = {
    className?: string;
    onCaseSelected?: (caseObj?: Case) => void;
    caseId?: string;
    filterAvailableCases?: (caseObj: Case) => boolean;
    includeClearOption?: boolean;
    clearOptionText?: string;
    title?: string;
    size?: 'small' | 'medium' | 'large';
    appearance?: 'outline' | 'filled-darker' | 'filled-lighter' | 'underline';
};
export const CaseDropdown = (props: CaseDropdownProps) => {
    const {
        className,
        onCaseSelected,
        caseId,
        filterAvailableCases,
        includeClearOption = false,
        clearOptionText = 'Clear Filter',
        title,
        size = 'medium',
        appearance,
    } = props;

    //Hooks
    const caseService = useCaseService();
    const cases = caseService.cases.filter(filterAvailableCases || (() => true));

    //State
    const [selectedCaseId, setSelectedCaseId] = useState<string | undefined>(caseId || '');

    const clearValue = '';

    //UI Events
    const optionChanged = (optionValue: string) => {
        if (optionValue === clearValue) {
            setSelectedCaseId(undefined);
        } else {
            setSelectedCaseId(optionValue);
        }
    };

    //Logic
    const getCaseOptions = () => {
        if (!!cases.length)
            return cases.map((caseObj) => ({
                label: caseObj.caseName || '',
                value: caseObj.caseId || '',
                component: <CaseControl caseObj={caseObj} noNavToCase />,
            }));
        return [];};

    //Effects
    useEffect(() => {
            setSelectedCaseId(caseId);
    }, [caseId]);

    useEffect(() => {
        const selCase = !!selectedCaseId ? caseService.findCaseById(selectedCaseId) : undefined;
        onCaseSelected && onCaseSelected(selCase);
    }, [selectedCaseId]);

    return (
        <DropdownMenu
            title={title}
            size={size}
            className={className}
            options={
                !!cases.length
                    ? [...(includeClearOption ? [{ label: clearOptionText, value: clearValue }] : []), ...getCaseOptions()]
                    : [{ label: 'No cases found', value: clearValue }]
            }
            appearance={appearance}
            onOptionChanged={optionChanged}
            initialValue={selectedCaseId}
            dataTestId='case-filter-menu'
            placeholder='Select a Case'
        />
    );
};
